export interface UserAgentSummary {
  /** "Chrome 141", "Safari 18"; null when the string names no known browser. */
  browser: string | null;
  /** "macOS", "iOS 18", "Windows", "Android 15"; null when unknown. */
  system: string | null;
}

// Order matters: Edge and Opera also say Chrome, Chrome also says Safari, iOS browsers say Safari.
const BROWSERS: Array<[name: string, pattern: RegExp]> = [
  ['Edge', /Edg(?:e|A|iOS)?\/(\d+)/],
  ['Opera', /(?:OPR|Opera)\/(\d+)/],
  ['Samsung Internet', /SamsungBrowser\/(\d+)/],
  ['Firefox', /(?:Firefox|FxiOS)\/(\d+)/],
  ['Chrome', /(?:Chrome|CriOS)\/(\d+)/],
  ['Safari', /Version\/(\d+)[.\d]* (?:Mobile\/\S+ )?Safari/],
];

function systemOf(ua: string): string | null {
  const ios = /(?:iPhone|iPad|iPod).*? OS (\d+)/.exec(ua);
  if (ios) return `iOS ${ios[1]}`;
  const android = /Android (\d+)/.exec(ua);
  if (android) return `Android ${android[1]}`;
  if (ua.includes('Windows')) return 'Windows';
  if (/Mac OS X|Macintosh/.test(ua)) return 'macOS';
  if (ua.includes('CrOS')) return 'ChromeOS';
  if (ua.includes('Linux')) return 'Linux';
  return null;
}

/** Browser and system from a user agent, for the visitor details; good enough to read, not to sniff. */
export function summarizeUserAgent(ua: string | null): UserAgentSummary {
  if (!ua) return { browser: null, system: null };
  const match = BROWSERS.map(([name, pattern]) => [name, pattern.exec(ua)] as const).find(
    ([, found]) => found !== null,
  );
  return {
    browser: match ? `${match[0]} ${match[1]?.[1] ?? ''}`.trim() : null,
    system: systemOf(ua),
  };
}
